<template>
  <div class="pb-2">
    <vs-button @click="open" class="w-full" type="border">{{
      title
    }}</vs-button>
    <vs-prompt
      :title="title"
      accept-text="Filtrar"
      cancel-text="Cancelar"
      button-cancel="border"
      @cancel="cancel"
      @accept="save"
      @close="cancel"
      :is-valid="validateForm"
      :active.sync="activePrompt"
    >
      <div class="modal-size">
        <form class="mx-2">
          <div class="vx-row">
            <div class="vx-col w-1/2">
              <span class="vs-input--label">Acumulado</span>
              <vs-switch v-model="item.acumulado" />
            </div>
            <div class="vx-col w-1/2">
              <span class="vs-input--label">Alimentação manual</span>
              <vs-switch v-model="item.alimentacao_manual" />
            </div>
            <div class="vx-col w-1/2 mt-2">
              <span class="vs-input--label">Responsável</span>
              <el-select
                class="w-full"
                filterable
                clearable
                v-model="item.id_responsavel"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(obj, index) in usuarios"
                  :value="obj.id"
                  :label="obj.nome"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <div class="vx-col w-1/2 mt-2">
              <span class="vs-input--label">Origem</span>
              <el-select
                class="w-full"
                filterable
                clearable
                v-model="item.id_origem"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(obj, index) in origens"
                  :value="obj.id"
                  :label="obj.nome"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <div class="vx-col w-1/2 mt-2">
              <span class="vs-input--label">Frequência</span>
              <el-select
                class="w-full"
                filterable
                clearable
                v-model="item.id_frequencia"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(obj, index) in frequencias"
                  :value="obj.id"
                  :label="obj.nome"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <div class="vx-col w-1/2 mt-2">
              <span class="vs-input--label">Sentido</span>
              <el-select
                class="w-full"
                filterable
                clearable
                v-model="item.id_sentido"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(obj, index) in sentidos"
                  :value="obj.id"
                  :label="obj.nome"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <div class="vx-col w-1/2 mt-2">
              <span class="vs-input--label">Setor</span>
              <el-select
                class="w-full"
                filterable
                clearable
                v-model="item.id_setor"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(obj, index) in setores"
                  :value="obj.id"
                  :label="obj.nome"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <div class="vx-col w-1/2 mt-2">
              <span class="vs-input--label">Tipo</span>
              <el-select
                class="w-full"
                filterable
                clearable
                v-model="item.id_tipo"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(obj, index) in tipos"
                  :value="obj.id"
                  :label="obj.nome"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <div class="vx-col w-1/2 mt-2">
              <span class="vs-input--label">Objetivo</span>
              <el-select
                class="w-full"
                filterable
                clearable
                v-model="item.id_objetivo"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(obj, index) in objetivos"
                  :value="obj.id"
                  :label="obj.nome"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <div class="vx-col w-1/2 mt-2">
              <span class="vs-input--label">Eixo</span>
              <el-select
                class="w-full"
                filterable
                clearable
                v-model="item.id_eixo"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(obj, index) in eixos"
                  :value="obj.id"
                  :label="obj.nome"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <div class="vx-col w-1/2 mt-2">
              <span class="vs-input--label">Perspectiva</span>
              <el-select
                class="w-full"
                filterable
                clearable
                v-model="item.id_perspectiva"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(obj, index) in perspectivas"
                  :value="obj.id"
                  :label="obj.nome"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <div class="vx-col w-1/2 mt-2">
              <span class="vs-input--label">Iniciativa</span>
              <el-select
                class="w-full"
                filterable
                clearable
                v-model="item.id_iniciativa"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(obj, index) in iniciativas"
                  :value="obj.id"
                  :label="obj.nome"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
          </div>
        </form>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activePrompt: false,
      item: {},
      usuarios: [],
      setores: [],
      iniciativas: [],
      objetivos: [],
      origens: [],
      sentidos: [],
      tipos: [],
      eixos: [],
      perspectivas: [],
      frequencias: [],
    };
  },
  computed: {
    validateForm() {
      return true;
    },
  },
  methods: {
    async open() {
      this.activePrompt = true;
      await this.getData();
    },
    async getData() {
      await this.$vs.loading();
      await Promise.all([
        this.getUsuarios(0),
        this.getSetores(0),
        this.getSentidos(0),
        this.getOrigens(0),
        this.getFrequencias(0),
        this.getTipos(0),
        this.getObjetivos(0),
        this.getIniciativas(0),
        this.getEixos(0),
        this.getPerspectivas(0),
      ])
      await this.$vs.loading.close();
    },
    async saveData() {
      await this.$vs.loading();
      try {
        // this.rows = await this.$http.post(`${this.url}`, this.item);
        // this.$vs.notify(this.$notify.Success);
        this.$emit("done", {
          ...this.item,
          filtered: Object.keys(this.item).length > 0 ? true : false,
        });
        // await this.cancel();
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        await this.$vs.loading.close();
      }
    },
    async save() {
      if (this.validateForm) {
        await this.saveData();
      }
    },
    async cancel() {
      await Object.assign(this.item, {});
    },
    async getUsuarios(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.usuarios = await this.$http.get(`usuario`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
    async getIniciativas(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.iniciativas = await this.$http.get("estrategia_iniciativa");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
    async getObjetivos(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.objetivos = await this.$http.get("estrategia_objetivo");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
    async getOrigens(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.origens = await this.$http.get("indicador_origem");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
    async getSentidos(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.sentidos = await this.$http.get("indicador_sentido");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
    async getTipos(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.tipos = await this.$http.get("indicador_tipo");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
    async getEixos(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.eixos = await this.$http.get("estrategia_eixo");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
    async getPerspectivas(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.perspectivas = await this.$http.get("estrategia_perspectiva");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
    async getFrequencias(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.frequencias = await this.$http.get("indicador_frequencia");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
    async getSetores(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.setores = await this.$http.get(`setor`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
  },
  async mounted() {},
};
</script>
